import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Consorcio } from '../../model/consorcio';
import { Sucursal } from '../../model/sucursal';

import { ServiciosEspeciales } from '../../model/servicios-especiales';
import { CatalogoServicios } from '../../model/catalogo-servicios';
import { MonedaService } from '../../services/moneda.service';
import { ServicioEspecialService } from '../../services/servicio-especial.service';

import { CatalogoServiciosService } from '../../services/catalogo-servicios.service';
import { Moneda } from '../../model/moneda';

@Component({
  selector: 'app-servicio-especial-documento',
  templateUrl: './servicio-especial-documento.component.html',
  styleUrls: ['./servicio-especial-documento.component.css']
})
export class ServicioEspecialDocumentoComponent implements OnInit {

  @Input() codigoDocumento: string;
  @Input() codigoSucursal: string;
  @Input() codigoConsorcio: string;
  @Input() tipoDocumento: string;

  @Output() onReturn = new EventEmitter();


  public modoEdicion: boolean = false;
  public sucursal: Sucursal;
  public sucursales: Sucursal[];

  public documento: ServiciosEspeciales;
  public documentos: ServiciosEspeciales[];

  public filtro: string;
  public query: any;

  public monedas: Moneda[];
  public servicios: CatalogoServicios[];
  public servicioCobro: ServiciosEspeciales = new ServiciosEspeciales();
  public consorcio: Consorcio;

  constructor(
    private _servicios: CatalogoServiciosService,
    private _monedaService: MonedaService,
    private _cobro: ServicioEspecialService
  ) { }

  ngOnInit() {

    this.filtro = "";
    this.documentos = [];

    if (sessionStorage.getItem("login") === null) {
      window.location.href = "/";
    }

    this._monedaService.getMonedas()
      .subscribe(
      monedas => this.monedas = monedas,
      err => {
        console.log(err);
      });

    this.consorcio = new Consorcio();
    this.consorcio.codigoConsorcio = this.codigoConsorcio;
    this.servicioCobro.codigoDocumento = this.codigoDocumento;
    this.servicioCobro.codigoConsorcio = this.codigoConsorcio;
    this.servicioCobro.codigoSucursal = this.codigoSucursal;
    this.servicioCobro.tipoDocumento = this.tipoDocumento;
    this.cargarDocumentos();
  }

  cargarDocumentos() {
    this.query = {
      codigoConsorcio: this.consorcio.codigoConsorcio,
      codigoSucursal: this.codigoSucursal,
      codigoDocumento: this.codigoDocumento
    };
    this._cobro.getCobrosDocumento(this.query)
      .subscribe(
      data => {
        this.documentos = data;
        this.query = { "codigoConsorcio": this.consorcio.codigoConsorcio };
        this._servicios.getServicios(this.query)
          .subscribe(
          data => {
            this.servicios = data;
            for (let i = 0; i < this.documentos.length; i++) {
              for (let x = 0; x < this.servicios.length; x++) {
                if (this.documentos[i].codigoServicio === this.servicios[x].codigoServicio) {
                  this.documentos[i].nombreServicio = this.servicios[x].descripcionServicio;
                  break;
                }
              }
            }
          },
          err => {
            console.log(err._body);
          });
      },
      err => {
        console.clear();
        console.log(err._body);
      });
  }

  agregarRegistro() {
    this.consorcio = new Consorcio();
    this.consorcio.codigoConsorcio = this.codigoConsorcio;
    this.servicioCobro = new ServiciosEspeciales();
    this.servicioCobro.codigoDocumento = this.codigoDocumento;
    this.servicioCobro.codigoConsorcio = this.codigoConsorcio;
    this.servicioCobro.codigoSucursal = this.codigoSucursal;
    this.servicioCobro.tipoDocumento = this.tipoDocumento;
    this.servicioCobro.cantidad = 1;
    this.servicioCobro.id = 0;
    this.modoEdicion = true;
    this.cargarServicios();
  }


  asignarCostoEstandar(codigoServicio: string) {
    for (let i = 0; i < this.servicios.length; i++) {
      if (this.servicios[i].codigoServicio === codigoServicio) {
        this.servicioCobro.montoServicio = this.servicios[i].costoEstandar;
        break;
      }
    }
    this.calcularTotal();
  }

  calcularTotal() {
    this.servicioCobro.total = (this.servicioCobro.cantidad * this.servicioCobro.montoServicio);
  }

  cargarServicios() {
    this.query = { "codigoConsorcio": this.consorcio.codigoConsorcio };
    this._servicios.getServicios(this.query)
      .subscribe(
      data => this.servicios = data,
      err => {
        console.log(err._body);
      });
  }

  onSubmit() {
    if (this.servicioCobro.id === 0) {
      this.servicioCobro.estado = "PENDIENTE";
    }
    this._cobro.insert(this.servicioCobro).subscribe(
      result => this.onSubmitSuccess(result),
      err => {
        console.log(err._body);
      });
  }

  onSubmitSuccess(data: any) {
    this.regresar();
  }

  regresar() {
    this.modoEdicion = false;
    this.cargarDocumentos();
    // this.onReturn.emit();
  }

  editarRegistro(documento: ServiciosEspeciales) {
    this.servicioCobro = documento;
    this.modoEdicion = true;
    this.cargarServicios();
  }



}



// WEBPACK FOOTER //
// D:/TPL ILG/3PL_ILG/src/app/components/servicio-especial-documento/servicio-especial-documento.component.ts